export default "__VITE_ASSET__BXavZ99X__"